/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable object-curly-newline */
/* eslint-disable import/prefer-default-export */
import mbpLogger from 'mbp-logger';
import jwtDecode from 'jwt-decode';
import configENV from '../../config';
import { isEmpty } from '../../utils/object';
import brandThemes from '../../../../components/AppShell/brandtheme';
import * as authData from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';
import { dateMMMMDDYYYY, dateMMMMDD, DDMMMYY } from '../../utils/dateString';
import { isBefore, isSameDay } from 'date-fns';
import mbpUtil from 'mbp-api-util';

const {
    DEV_ENV,
    ACCESS_TOKEN,
    ID_TOKEN,
    IS_AUTHENTICATED,
    PERSIST_KEY,
    SESSION_STORAGE_ENABLED,
} = configENV;

const refactorObjectData = (countries) => {
    const newArray = [];
    Object.keys(countries).forEach((key) => {
        newArray.push({ id: key, name: countries[key] });
    });
    return newArray;
};

const refactorStateData = (states) => {
    const newState = {};
    Object.keys(states).forEach((key) => {
        newState[key] = [];
        Object.keys(states[key]).forEach((k) => {
            newState[key].push({ id: k, name: states[key][k] });
        });
    });
    return newState;
};

const getAuthentication = () => {
    const REACT_APP_INJECTABLE = mbpUtil.getEnv('REACT_APP_INJECTABLE');
    if (REACT_APP_INJECTABLE === 'false'){
        return false;
    }
    if (DEV_ENV) {
        const isAuthenticated = ACCESS_TOKEN && ID_TOKEN ? IS_AUTHENTICATED : false;
        return {
            isAuthenticated,
            accessToken: ACCESS_TOKEN,
            idToken: ID_TOKEN,
        };
    }
    try {
        const auth = JSON.parse(JSON.parse(sessionStorage.getItem('persist:member')).auth);
        if (!auth.user_profile) {
            auth.idToken = localStorage.getItem('user_profile');
        } else if (!auth.idToken) {
            auth.idToken = auth.user_profile;
        }
        return auth;
    } catch (ex) {
        return {};
    }
};

const setState = (state, content) => {
    const newState = { ...state, ...content };
    if (SESSION_STORAGE_ENABLED === 'on') {
        let { billingAddress, wallet, recipients, orderList } = content;
        const { ContactId } = newState;
        if (
            (billingAddress || wallet || recipients || orderList)
            && ContactId
        ) {
            const accountStorage = sessionStorage.getItem(PERSIST_KEY);
            if (accountStorage) {
                let storageJson = JSON.parse(accountStorage);
                if (!storageJson) storageJson = { [ContactId]: {} };
                if (recipients) {
                    ({ recipients } = newState);
                    storageJson[ContactId] = {

                        ...storageJson[ContactId],
                        recipients,
                        timestamp: new Date().getTime(),
                    };
                }
                if (billingAddress) {
                    ({ billingAddress } = newState);
                    storageJson[ContactId] = {

                        ...storageJson[ContactId],
                        billingAddress,
                        timestamp: new Date().getTime(),
                    };
                }
                if (wallet) {
                    ({ wallet } = newState);
                    storageJson[ContactId] = {

                        ...storageJson[ContactId],
                        wallet,
                        timestamp: new Date().getTime(),
                    };
                }
                if (orderList) {
                    ({ orderList } = newState);
                    storageJson[ContactId] = {

                        ...storageJson[ContactId],
                        orderList,
                        timestamp: new Date().getTime(),
                    };
                }
                sessionStorage.setItem(
                    PERSIST_KEY,
                    JSON.stringify(storageJson),
                );
            }
        }
    }
    return newState;
};

const setSessionStorageObject = (ContactId, object, isSession = true) => {
    const Storage = isSession ? sessionStorage : localStorage;
    const accountStorage = Storage.getItem(PERSIST_KEY);
    let storageJson = accountStorage
        ? JSON.parse(accountStorage)
        : { [ContactId]: {} };
    const commonStorage = storageJson.common;
    if (!storageJson[ContactId] && !commonStorage) {
        storageJson = { [ContactId]: {} };
    } else if (commonStorage) {
        storageJson = { common: commonStorage };
    }
    storageJson[ContactId] = { ...storageJson[ContactId], ...object };
    Storage.setItem(PERSIST_KEY, JSON.stringify(storageJson));
    return object;
};

const getSessionStorageObject = (ContactId, objectKey, isSession = true) => {
    const Storage = isSession ? sessionStorage : localStorage;
    const accountStorage = Storage.getItem(PERSIST_KEY);
    const storageJson = accountStorage
        ? JSON.parse(accountStorage)
        : { [ContactId]: {} };
    if (storageJson[ContactId] && storageJson[ContactId][objectKey]) {
        return storageJson[ContactId][objectKey];
    }
    return {};
};

export const getChannelUser = (deviceType, pathname, featureFlag) => {
    const userDevice = deviceType === 'mobile' ? 'mobile' : 'desktop';
    const defaultCode = userDevice === 'mobile' ? '30002' : '30001';

    const brands = {
        '1800flowers': { desktop: '30016', mobile: '30026' },
        '1800baskets': { desktop: '30017', mobile: '30027' },
        fruitbouquets: { desktop: '30018', mobile: '30028' },
        simplychocolate: { desktop: '30019', mobile: '30029' },
        berries: { desktop: '30020', mobile: '30030' },
        harryanddavid: { desktop: '30021', mobile: '30031' },
        wolfermans: { desktop: '30022', mobile: '30032' },
        stockyards: { desktop: '30023', mobile: '30033' },
        thepopcornfactory: { desktop: '30024', mobile: '30034' },
        cheryls: { desktop: '30025', mobile: '30035' },
        vitalchoice: { desktop: '30079', mobile: '30080' },
        florists: { desktop: '30139', mobile: '30140' },
    };
    if (featureFlag) {
        return brands?.[pathname]?.[userDevice] || defaultCode;
    }
    return defaultCode;
};

const getGiftListItemFromCart = ({ data }) => {
    try {
        const {
            orderDetails: {
                fdOrderVO: {
                    orderId,
                    recipients,
                    status,
                },
            },
        } = data;
        let returnData = {};
        if (!isEmpty(recipients)) {
            recipients.forEach((recipient) => {
                const { orderItems, recipientAddress } = recipient;
                if (!isEmpty(orderItems) && !isEmpty(recipientAddress)) {
                    orderItems.forEach((order) => {
                        const {
                            addressId,
                            orderItemsId: orderItemId,
                            xOrderAttrValues,
                            promisedAvailableTime,
                            catalogEntryVO: {
                                parentCatentryId,
                                skuCode: partNumber,
                                parentSkuName: name,
                                imagePath,
                                flowersImgName,
                                skuListPrice,
                                skuOfferPrice,
                                parentCatentryId: parentCatalogEntryId,
                            },
                        } = order;
                        // Get product SKU from partNumber: cco_222211 or cco_VDY16_156991
                        const sku = partNumber.replace(/[^-]+-[IP]-/, '').replace(/([^_]+_)*(\d+)$/g, '$2');
                        // Don't add 'c.jpg' if flowersImgName already ended by .jpeg or .png
                        const image = /\.(jpe?g|png)$/.test(flowersImgName) ? `${imagePath}${flowersImgName}` : `${imagePath}${flowersImgName}c.jpg`;
                        const productDetail = {
                            content: '',
                            crossedPrice: (skuListPrice === skuOfferPrice) ? '' : skuListPrice,
                            discountPrice: (skuListPrice === skuOfferPrice) ? '' : skuOfferPrice,
                            id: partNumber,
                            image,
                            flowersImgName,
                            imagePath,
                            name,
                            parentCatalogEntryId,
                            partNumber,
                            price: skuListPrice,
                            sku,
                        };
                        if (status === 'M') {
                            returnData = {};
                        } else {
                            returnData[orderItemId] = {
                                addressId,
                                orderId,
                                orderItemId,
                                parentCatentryId,
                                sku,
                                xOrderAttrValues,
                                productDetail,
                                promisedAvailableTime,
                            };
                        }
                    });
                }
            });
        }
        return returnData;
    } catch (ex) {
        return {};
    }
};

const getItemDetailsFromCart = (orderItemId, productsInCart) => {
    let productDetail = {};
    let hasDeliveryDate = false;
    if (!isEmpty(productsInCart)) {
        // eslint-disable-next-line consistent-return
        Object.keys(productsInCart).forEach((addressId) => {
            const productInCart = productsInCart[addressId];
            const { promisedAvailableTime, xOrderAttrValues: { giftHistoryOrderItemId } } = productInCart;
            if (orderItemId === giftHistoryOrderItemId) {
                ({ productDetail } = productInCart);
                hasDeliveryDate = promisedAvailableTime !== '';
            }
        });
    }
    return {
        hasDeliveryDate,
        productDetail,
    };
};

const updateRecipientsFromCartItems = (recipients, occasionId, productsInCart) => {
    const newRecipients = recipients;
    // Adding default value of addToCart and cartDetail to recipient object
    if (!isEmpty(newRecipients[occasionId])) {
        newRecipients[occasionId].forEach((item, key) => {
            newRecipients[occasionId][key].addToCart = '';
            newRecipients[occasionId][key].cartDetail = {};
        });
    }
    if (!isEmpty(productsInCart)) {
        Object.keys(productsInCart).forEach((orderItemId) => {
            const productInCart = productsInCart[orderItemId];
            // Get giftHistoryOrderItemId from productInCart.xOrderAttrValues
            // MongoDB use giftHistoryOrderItemId (no `s`) instead of giftHistoryOrderItemsId (with `s`)
            let { xOrderAttrValues: { giftHistoryOrderItemId } } = productInCart;
            // For WCS
            if (!giftHistoryOrderItemId) {
                ({ xOrderAttrValues: { giftHistoryOrderItemsId: giftHistoryOrderItemId } } = productInCart);
            }
            // Update recipient object by adding: addToCart & cartDetail object
            // cartDetail object will be used as an item in cart indicator for Gift List
            // Look into DesktopRecipientDetails.js, MobileRecipientDetails.js, and ProductAddedToCart.js for more info
            if (!isEmpty(newRecipients[occasionId]) && giftHistoryOrderItemId) {
                newRecipients[occasionId].forEach((item, key) => {
                    if (item.orderItemId === giftHistoryOrderItemId) {
                        const { products } = item;
                        const sku = productInCart.sku.replace(/-P-/, '-I-').replace(/([^_]+_)*(\d+)$/g, '$2'); // Get product SKU from partNumber: cco_222211 or cco_VDY16_156991
                        newRecipients[occasionId][key].addToCart = sku;
                        newRecipients[occasionId][key].cartDetail = {
                            orderId: productInCart.orderId,
                            orderItemId: productInCart.orderItemId,
                            skuCatentryId: productInCart.parentCatentryId,
                        };
                        products.forEach((prod) => {
                            if (prod.partNumber === sku) {
                                newRecipients[occasionId][key].cartDetail.productDetail = {
                                    ...prod,
                                };
                            }
                        });
                        // If users added product by product number
                        if (isEmpty(newRecipients[occasionId][key].cartDetail.productDetail)) {
                            newRecipients[occasionId][key].cartDetail.productDetail = productInCart.productDetail;
                        }
                    }
                });
            }
        });
    }
    return newRecipients;
};

const checkRemainingRecipient = (recipients, occasionId) => {
    let counter = 0;
    if (!isEmpty(recipients[occasionId])) {
        recipients[occasionId].forEach((item, key) => {
            if (!recipients[occasionId][key].addToCart) {
                counter += 1;
            }
        });
    }
    return counter;
};

export const GIFT_MESSAGE_SIZE = 180;

const brandIdByCode = {
    1001: '18F',
    1019: 'HD',
    1009: '18B',
    1025: 'SCH',
    1010: 'FB',
    1012: 'CCO',
    1022: 'PZU',
    1002: 'TPF',
    1020: 'WLF',
    1018: 'SY',
    1029: 'BRY',
    1030: 'PMA',
};

const getGiftMessageConfiguration = (brandId) => {
    if (brandId) {
        const { giftMessageConfig } = brandThemes[brandIdByCode[brandId] || '18F'];
        return giftMessageConfig;
    }

    return {
        giftMessageMaxLines: 4,
        giftMessageMaxChars: 30,
    };
};

const convertMultilineStr = (str, n, acc) => {
    if (str.length === 0) {
        return acc;
    }
    acc.push(str.substring(0, n));
    return convertMultilineStr(str.substring(n), n, acc);
};

const isLoginRequired = (featureFlags, scope = '', writeAccess = true) => {
    if (!featureFlags || !scope) return false;

    const isKMSIEnabled = (featureFlags?.['is-keep-me-signed-in-redirect-enabled'] === true) || false;
    const signedInRedirectVariant = (featureFlags?.['is-keep-me-signed-in-redirect-variant']) || {};
    // ignore is login required if the is-keep-me-signed-in-redirect-enabled flag is OFF
    if (isKMSIEnabled !== true) return false;

    const pathname = (typeof window !== 'undefined' && window.location?.pathname) ? window.location?.pathname : '';
    const pathnameSplit = pathname.split(/\//g);
    let page = (pathname && pathnameSplit[2]) ? pathnameSplit[2] : '';
    if (pathname && page === '' && /\/account[/?]?/.test(pathname)) {
        page = 'home';
    }
    if (page && signedInRedirectVariant?.[page] && scope && /((read|write):account)/g.test(scope)) { // prevented undefined scope
        // If the API requires full access, but the scope returns as read only access
        // then we redirect users to login page (return true)
        if (writeAccess) {
            return /(read:account)/g.test(scope);
        }
    }
    // Do not redirect if the featureFlag is off
    return false;
};

const redirectToLogin = async (featureFlags, loginByRedirect) => {
    // Handle redirect to login if login required on click of cancel order button
    const accessToken = await authData.getAccessTokenSafely();
    const { scope = '' } = jwtDecode(accessToken);
    if (isLoginRequired(featureFlags, scope)) {
        loginByRedirect();
        return true;
    }
    return false;
};

const isHDBrand = (productBrand) => (productBrand === '1018' || productBrand === '1019' || productBrand === '1020' || productBrand === '1031');

const isFoodBrand = (productBrand) => (['1019', '1020', '1018', '1031'].includes(productBrand)); // Food Brands (HD, WLF, STY, VC). If not FOOD then it is FLORAL

const isFloralBrand = (productBrand) => (['1001', '1002', '1009', '1010', '1012', '1029', '1025', '1030', '1027', '1026'].includes(productBrand)); // Floral Brands (18F, 18B, FB, SCH, SB, pmall, goodsey, CCO)

const generateFloralResolutionBrand = (productBrand) => {
   if (productBrand === '1012' || productBrand === '1002') return productBrand;
   return '18F';
}

const getRangeDate = (arrivalStartDate, arrivalEndDate) => {
    // converting to standard date format because date-fns not support formatted dates
    let formattedArrivalStartDate = (arrivalStartDate !== '' && new Date(arrivalStartDate)) || ''; // Wed May 05 2021 00:00:00 GMT-0700 (PDT)
    let formattedArrivalEndDate = (arrivalEndDate !== '' && new Date(arrivalEndDate)) || ''; // Fri May 07 2021 00:00:00 GMT-0700 (PDT)
    if (formattedArrivalStartDate !== '' && formattedArrivalEndDate !== ''
        && formattedArrivalStartDate.toString() === 'Invalid Date'
        && formattedArrivalEndDate.toString() === 'Invalid Date'
    ) {
        // for safari we need to check for Invalid Date in DDMMMYY because its not supporting 2021-05-06 00:00:00 format
        formattedArrivalStartDate = new Date(DDMMMYY(arrivalStartDate)) || '';
        formattedArrivalEndDate = new Date(DDMMMYY(arrivalEndDate)) || '';
    }
    let [earlierDate, laterDate] = [arrivalStartDate, arrivalEndDate];
    // To avoid date flipping because of invalid date or same date
    if (formattedArrivalStartDate !== '' && formattedArrivalEndDate !== ''
        && formattedArrivalStartDate.toString() !== 'Invalid Date'
        && formattedArrivalEndDate.toString() !== 'Invalid Date'
        && !isSameDay(formattedArrivalStartDate, formattedArrivalEndDate)
    ) {
        // isBefore checks is Wed May 05 2021 before Fri May 07 2021
        [earlierDate, laterDate] = isBefore(formattedArrivalStartDate, formattedArrivalEndDate)
            ? [arrivalStartDate, arrivalEndDate] : [arrivalEndDate, arrivalStartDate];
    }
    return {
        earlierDate,
        laterDate,
    };
};

const getDeliveryDate = (
    exactDeliveryDate = '',
    arrivalStartDate = '',
    arrivalEndDate = '',
    productBrand = '',
    isflexDate = false,
    estimatedDate = '',
) => {
    let deliveryDate = '';
    let deliveryLabel = '';
    if (/[a-z]{3}-\d{4}/gi.test(estimatedDate || exactDeliveryDate)) { // if delivery date is Apr-2021,
        deliveryLabel = 'Arrives by';
        deliveryDate = estimatedDate || exactDeliveryDate;
    } else if (isflexDate) { // display range date if flex date available
        deliveryLabel = 'Arrives between';
        const { earlierDate, laterDate } = getRangeDate(arrivalStartDate, arrivalEndDate);
        if (arrivalStartDate.slice(0, 4) === arrivalEndDate.slice(0, 4)) { // 2021 === 2021 --> same year
            deliveryDate = `${dateMMMMDD(earlierDate)} - ${dateMMMMDDYYYY(laterDate)}`;
        } else { // stretch into the new year
            deliveryDate = `${dateMMMMDDYYYY(earlierDate)} - ${dateMMMMDDYYYY(laterDate)}`;
        }
    } else if (isFoodBrand(productBrand)) {  // FOOD BRANDS LOGIC
        deliveryLabel = 'Arrives by';
        const splittedDate = exactDeliveryDate?.split('-');
        const isDeliveryDateMonthYearFormate = (splittedDate?.length === 2 && splittedDate?.[0]?.length === 3 && splittedDate?.[1]?.length === 4); // (Aug - 2021) format
        if (estimatedDate !== '') { // display estimatedDate over below logic if its available
            deliveryDate = dateMMMMDDYYYY(estimatedDate);
        } else if ((isDeliveryDateMonthYearFormate && arrivalEndDate !== '') || (arrivalEndDate !== '' && exactDeliveryDate !== '' && exactDeliveryDate !== arrivalEndDate)) {
            deliveryDate = dateMMMMDDYYYY(arrivalEndDate);
        } else if ((arrivalStartDate === '' && arrivalEndDate === '') || (arrivalEndDate !== '' && exactDeliveryDate !== '' && exactDeliveryDate === arrivalEndDate) || (arrivalEndDate === '' && exactDeliveryDate)) {
            deliveryDate = dateMMMMDDYYYY(exactDeliveryDate);
        }
    } else if (productBrand === '1012') {
        if ((estimatedDate && estimatedDate !== '') && (arrivalStartDate === arrivalEndDate)) {
            deliveryLabel = 'Arrives on';
            deliveryDate = dateMMMMDDYYYY(estimatedDate);
        } else if (arrivalStartDate !== arrivalEndDate) {
            deliveryLabel = 'Arrives between';
            deliveryDate = `${dateMMMMDDYYYY(arrivalStartDate)} and ${dateMMMMDDYYYY(arrivalEndDate)}`
        } else {
            deliveryLabel = 'Arrives on';
            deliveryDate = dateMMMMDDYYYY(exactDeliveryDate);
        }
    } else { // floral
        deliveryLabel = 'Arrives on';
        deliveryDate = dateMMMMDDYYYY(estimatedDate !== '' ? estimatedDate : exactDeliveryDate); // display estimatedDate over below logic if its available
    }
    if (deliveryDate === ' NaN, NaN') {
        mbpLogger.logError({
            function: 'Helper.getDeliveryDate',
            appName: process.env.npm_package_name,
            module: 'mbp-account',
            message: 'Delivery date is NaN',
        })
    }
    return {
        deliveryLabel,
        deliveryDate,
    };
};

const checkIsDonationItem = (productName) => /(donation|fundraising)/gi.test(productName);
const checkIsPassportItem = (productName) => /passport annual membership|passport for|passport at/gi.test(productName);

const getPromCode = (brand, flag) => {
    // only HD brands require promCode
    if (flag) {
        switch (brand) {
            case '1018':
                // Stockyards
                return 'FAL23';
            case '1019':
                // Harry and David
                return 'FAL23';
            case '1020':
                // Wolferman's
                return 'WOW23';
            case '1031':
                // Vital Choice
                return 'VTC23';
            default:
                return '';
        }
    } else {
        switch (brand) {
            case '1018':
                // Stockyards
                return 'STY22';
            case '1019':
                // Harry and David
                return 'FAL22';
            case '1020':
                // Wolferman's
                return 'WOW22';
            case '1031':
                // Vital Choice
                return 'VTC22';
            default:
                return '';
        }
    }
};


/*
    returns true if this order is:
        card isle
        delivered
        product image contains 'cardisle.com/api/image'
*/

const isDeliveredCardIsle = ({
    deliveryStatus, addonType, prdImgCtg, prdImgTmn,
}) => deliveryStatus === 'D' && addonType === 'GCI' && /cardisle.com\/api\/image/gi.test(prdImgCtg || prdImgTmn);

const Helper = {
    refactorObjectData,
    refactorStateData,
    setState,
    getAuthentication,
    setSessionStorageObject,
    getSessionStorageObject,
    getChannelUser,
    getGiftListItemFromCart,
    getItemDetailsFromCart,
    updateRecipientsFromCartItems,
    checkRemainingRecipient,
    getGiftMessageConfiguration,
    convertMultilineStr,
    isLoginRequired,
    redirectToLogin,
    isHDBrand,
    checkIsDonationItem,
    getPromCode,
    isFoodBrand,
    isFloralBrand,
    getDeliveryDate,
    isDeliveredCardIsle,
    checkIsPassportItem,
    generateFloralResolutionBrand
};

export default Helper;
